import { AfterViewInit, Component } from '@angular/core'

import {
  NUMBER_FIVE_HUNDRED,
  NUMBER_HUNDRED,
} from '../../../constants/constant.numbers'
import { WaitForConditionPipe } from '../../shared/pipe/wait-for-condition.pipe'

// Extend the Window interface
declare global {
  interface Window {
    OneTrust?: any
  }
}

@Component({
  selector: 'app-global-footer',
  templateUrl: './global-footer.component.html',
  styleUrls: ['./global-footer.component.scss'],
})
export class GlobalFooterComponent implements AfterViewInit {
  constructor(private waitForCondition: WaitForConditionPipe) {}

  ngAfterViewInit(): void {
    this.popUpDoNotSellLink()
  }

  popUpDoNotSellLink() {
    this.waitForCondition
      .transform(
        () => {
          const el = document.getElementById('SF_CA_NO_SELL')
          return el !== null && el !== undefined
        },
        NUMBER_FIVE_HUNDRED,
        NUMBER_HUNDRED,
      )
      .then(() => {
        const el = document.getElementById('SF_CA_NO_SELL')
        if (el) {
          el.addEventListener('click', (e) => {
            e.preventDefault()
            window.OneTrust.ToggleInfoDisplay()
          })
        }
      })
  }
}
